// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export interface IEntityTrigger {
  event: string;
  target: string;
}
